module.exports = __webpack_public_path__ + "media/Our Wolrd.92600f13.mp3";